/* Loupe – "Pairs well with" on the product page.
   Loads Shopify's complementary recommendations (section product-complementary), falls back to related
   products if none are set up, stays hidden when there is nothing to show. Results are cached so the
   block refills instantly after a variant change re-renders the product info. */
(() => {
  if (customElements.get('loupe-complementary')) return;
  const pending = new Map();
  const done = new Map();

  const load = (url) => {
    if (!pending.has(url)) {
      pending.set(url, fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-complementary]');
          const out = box && box.children.length ? box.innerHTML : '';
          done.set(url, out);
          return out;
        })
        .catch(() => ''));
    }
    return pending.get(url);
  };

  class LoupeComplementary extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-comp-list]');
      const url = this.dataset.url;
      if (!this.list || !url) return;
      this.related = this.hasAttribute('data-fallback') ? url.replace('intent=complementary', 'intent=related') : null;

      /* already fetched for this product: fill synchronously, no flash */
      const cached = done.get(url) || (this.related && done.get(url) === '' ? done.get(this.related) : undefined);
      if (cached) return this.fill(cached);

      if (!('IntersectionObserver' in window)) return this.run();
      this.io = new IntersectionObserver((es) => {
        if (!es[0].isIntersecting) return;
        this.io.disconnect(); this.run();
      }, { rootMargin: '0px 0px 600px 0px' });
      this.io.observe(this.closest('[data-product-info]') || this);
    }

    disconnectedCallback() { this.io && this.io.disconnect(); }

    async run() {
      let html = await load(this.dataset.url);
      if (!html && this.related) html = await load(this.related);
      if (html) this.fill(html); else this.hidden = true;
    }

    fill(html) {
      this.list.innerHTML = html;
      this.classList.add('is-loaded');
    }
  }

  customElements.define('loupe-complementary', LoupeComplementary);
})();
